import React, { useEffect } from 'react';
import { Input, Form, Checkbox } from 'antd';
import useLogin from 'hooks/useLogin';
import Logo from 'assets/images/wing-logo.svg';
import { forgotPasswordModalVisible } from 'cache';
import { LoginReq } from 'services/auth';
import { useLoggedInStateQuery } from 'graphql/types';
import { useHistory, useLocation } from 'react-router-dom';
import {
  AuthPage,
  LoginAuthPageCard,
  LoginBody,
  LogoMark,
  LoginHeading,
  LoginSubheading,
  StyledForm,
  OptionsRow,
  ForgotLink,
  SignInButton,
  LoginFooter,
  SignUpLink,
} from './login.styled';

type LoginLocationState = {
  from?: { pathname?: string };
};

function Login() {
  const [loginLoading, onLogin] = useLogin();
  const [loginForm] = Form.useForm();
  const history = useHistory();
  const location = useLocation<LoginLocationState>();
  const { data: loggedInData } = useLoggedInStateQuery();

  useEffect(() => {
    if (loggedInData?.loggedInState) {
      history.replace(location.state?.from?.pathname || '/account');
    }
  }, [history, location.state, loggedInData]);

  const onFinish = (values: unknown) => {
    const { identifier, password } = values as LoginReq;
    onLogin({ identifier, password }, () => {
      history.replace(location.state?.from?.pathname || '/account');
    });
  };

  const toSignup = () => {
    history.push('/signup');
  };

  const forgotPassword = () => {
    forgotPasswordModalVisible(true);
  };

  return (
    <AuthPage>
      <LoginAuthPageCard>
        <LoginBody>
          <LogoMark>
            <img src={Logo} alt="wing" />
          </LogoMark>
          <LoginHeading>Hi! Welcome</LoginHeading>
          <LoginSubheading>Please sign in to your account</LoginSubheading>
        </LoginBody>
        <StyledForm
          layout="vertical"
          form={loginForm}
          onFinish={onFinish}
          preserve={false}
          initialValues={{ remember: false }}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              e.preventDefault();
              loginForm.submit();
            }
          }}
        >
          <Form.Item
            name="identifier"
            label="Email"
            rules={[
              { type: 'email', message: 'The input is not valid E-mail!' },
              { required: true, message: 'Please input your Email!' },
            ]}
          >
            <Input className="login-input-email" placeholder="Enter your email" autoComplete="email" />
          </Form.Item>
          <Form.Item name="password" label="Password" rules={[{ required: true, message: 'Password is required!' }]}>
            <Input.Password
              className="login-input-password"
              placeholder="Enter your password"
              autoComplete="current-password"
            />
          </Form.Item>
          <OptionsRow>
            <Form.Item name="remember" valuePropName="checked" style={{ marginBottom: 0 }}>
              <Checkbox>Remember me</Checkbox>
            </Form.Item>
            <ForgotLink type="button" onClick={forgotPassword}>
              Forgot password?
            </ForgotLink>
          </OptionsRow>
          <Form.Item style={{ marginBottom: 0 }}>
            <SignInButton htmlType="submit" loading={loginLoading}>
              Sign in
            </SignInButton>
          </Form.Item>
        </StyledForm>
        <LoginFooter>
          Don&apos;t have an account?{' '}
          <SignUpLink type="button" onClick={toSignup}>
            Sign up
          </SignUpLink>
        </LoginFooter>
      </LoginAuthPageCard>
    </AuthPage>
  );
}

export default Login;
